import Vue from 'vue'
import VueRouter from 'vue-router'
import { Home, MarketPlace, Preview , Custom} from '@/views';
import { Landing } from '../views';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/templyfy-tailwind-editor',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/create',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/marketplace',
    name: 'marketplace',
    component: MarketPlace,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/preview',
    name: 'preview',
    component: Preview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/custom',
    name: 'custom',
    component: Custom,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login,
  //   meta: {
  //     requiresAuth: false
  //   }
  // },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


// router.beforeEach((to, from, next) => {
//   if (to.name === 'login') {
//     const authUser = JSON.parse(window.localStorage.getItem('authUser'))
//     if (authUser && authUser.stsTokenManager.accessToken) {
//       next({ name: 'home' })
//     } else {
//       next();
//     }
//   }
//   if (to.meta.requiresAuth) {
//     const authUser = JSON.parse(window.localStorage.getItem('authUser'))
//     if (authUser && authUser.stsTokenManager.accessToken) {
//       next()
//     } else {
//       next({ name: 'login' })
//     }
//   }
//   next()
// })
export default router
